import React, { useEffect, useState } from "react";
import { SimpleGrid, Box, Text, Spinner, Flex, Stat, StatLabel, StatNumber, StatHelpText } from "@chakra-ui/react";
import axios from "axios";

const API = process.env.REACT_APP_API_URL;

const getColor = (pct) => {
  if (pct >= 95) return { bg: "green.50", border: "green.400", text: "green.600" };
  if (pct >= 80) return { bg: "yellow.50", border: "yellow.400", text: "yellow.600" };
  return { bg: "red.50", border: "red.400", text: "red.600" };
};

const SohCoverage = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCoverage();
  }, []);

  const fetchCoverage = async () => {
    try {
      const res = await axios.post(`${API}/validation/soh-coverage`, {});
      setData(res.data?.data || []);
    } catch (err) {
      console.error("Failed to fetch SOH coverage", err);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <Flex justify="center" p={8}><Spinner size="lg" /></Flex>;
  if (data.length === 0) return <Text fontSize="sm" color="gray.500" textAlign="center">No coverage data</Text>;

  return (
    <SimpleGrid columns={{ base: 2, md: 3, lg: 5 }} spacing={4}>
      {data.map((row) => {
        const pct = parseFloat(row.coverage_pct) || 0;
        const colors = getColor(pct);
        return (
          <Box
            key={row.retailer}
            p={4}
            bg={colors.bg}
            borderRadius="lg"
            borderLeft="4px solid"
            borderLeftColor={colors.border}
            transition="all 0.3s ease"
            _hover={{ transform: "translateY(-2px)", boxShadow: "md" }}
          >
            <Stat>
              <StatLabel fontSize="xs" textTransform="uppercase" color="gray.500" fontWeight="600">{row.retailer}</StatLabel>
              <StatNumber fontSize="2xl" color={colors.text}>{pct}%</StatNumber>
              <StatHelpText fontSize="xs" mb={0}>
                {row.sdc_stores} / {row.sales_stores} stores
              </StatHelpText>
            </Stat>
          </Box>
        );
      })}
    </SimpleGrid>
  );
};

export default SohCoverage;
